import { FormBase } from 'core/components';

export default class ProductOrderUploadForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'file',
                    label: 'PRODUCT.UPLOAD.FILE_LABEL',
                    placeholder: 'PRODUCT.UPLOAD.FILE_PLACEHOLDER',
                    type:'file'
                }
            ],
        };
    }
}
